import clsx from 'clsx'

import Statistics from './tabs/Statistics'
import { TaskList } from './tabs/TaskList'

import { useParams, useSearchParams } from 'react-router-dom'
import { useGetDispatcherTechnicianScheduleQuery } from '@/services/dispatcher/dispather'
import Image from '@/compoments/common/Image'
import PageLoader from '@/compoments/PageLoader'
import { useState } from 'react'
import { getMediaUrl } from '@/utils/helpers'
import { WorkingSchedule } from './tabs/WorkingSchedule'

const TechnicianPage = () => {
    const { id } = useParams()
    const [searchParams] = useSearchParams()
    const queryString = searchParams.toString()
    const { data, isLoading } = useGetDispatcherTechnicianScheduleQuery(
        {
            id: Number(id),
            query: `no_limit=true&${queryString}`,
        },
        { skip: !id || !searchParams.get('startDate') },
    )
    const pageData = data?.data
    const tabs = [
        {
            id: 'working_schedule',
            label: 'Working Schedule',
        },
        {
            id: 'task_list',
            label: 'Task List',
        },
        {
            id: 'statistics',
            label: 'Stastics',
        },
    ]
    const [activeTab, setActiveTab] = useState(tabs[0].id)
    if (isLoading) {
        return <PageLoader />
    }
    return (
        <main className="content flex flex-col">
            <div className="px-container flex flex-col flex-auto">
                <div className="card-user-info mb-18 user-info-items">
                    <div className="card-user-info__item flex items-center gap-18">
                        <div className="user-photo-60x60">
                            <Image
                                src={getMediaUrl(pageData?.user?.photo || '')}
                                width={60}
                                height={60}
                            />
                        </div>

                        <div className="flex flex-col">
                            <h5 className="mb-4px">
                                {pageData?.user?.fullName}
                            </h5>
                            <span className="text--xs text-color-1">
                                {pageData?.user?.email}
                            </span>
                            <span className="text--xs text-color-1">
                                {pageData?.user?.phone}
                            </span>
                        </div>
                    </div>
                    <div className="card-user-info__item flex flex-col items-center">
                        <h2 className="mb-4px color-primary">
                            {pageData?.user?.score?.rating}
                        </h2>
                        <span className="text--xs text-color-1 fw-500">
                            Rank #{pageData?.user?.score?.rank}
                        </span>
                    </div>
                    <div className="card-user-info__item flex flex-col items-center">
                        <h2 className="mb-4px">
                            {pageData?.user?.score?.completed}
                        </h2>
                        <span className="text--xs color-success-bold">
                            Completed
                        </span>
                    </div>
                    <div className="card-user-info__item flex flex-col items-center">
                        <h2 className="mb-4px">{pageData?.user?.score?.kiv}</h2>
                        <span className="text--xs text-color-1">KIV</span>
                    </div>
                    <div className="card-user-info__item flex flex-col items-center">
                        <h2 className="mb-4px">
                            {pageData?.user?.score?.canceled}
                        </h2>
                        <span className="text--xs color-danger">Canceled</span>
                    </div>
                    <div className="card-user-info__item flex flex-col items-center">
                        <h2 className="mb-4px">
                            {pageData?.user?.score?.pending}
                        </h2>
                        <span className="text--xs color-warning-bold">
                            Pending
                        </span>
                    </div>
                </div>
                <div className="table-group tabs flex flex-col flex-auto">
                    <div className="table-filter-actions tabs-links-list modal__tabs__body">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={clsx(
                                    'btn full-radius btn--xs btn-tab-custom',
                                    { 'active-tab': activeTab === tab.id },
                                )}
                            >
                                <span>{tab.label}</span>
                            </button>
                        ))}
                    </div>
                    <div className="tabs-body flex-auto">
                        {activeTab === 'working_schedule' && (
                            <WorkingSchedule events={pageData?.orders} />
                        )}
                        {activeTab === 'task_list' && <TaskList />}
                        {activeTab === 'statistics' && <Statistics />}
                    </div>
                </div>
            </div>
        </main>
    )
}

export default TechnicianPage
